export enum ApiQueryKeys {
  CLUSTERS = 'clusters',
  PRACTITIONERS = 'practitioners',
  COMMUNITY_TAGS = 'community-tags',
  SKILLS = 'skills',
  EXPERIENCES = 'experiences',
  CAROUSEL = 'carousel',
  VISIBILITY_PREFERENCES = 'visibility-preferences',
  PREFERENCES_VISIBILITY_USERS = 'preferences-visibility-users',
  ME = 'me',
  COMPANIES = 'companies',
  JOB_FAMILY_NAMES = 'job-family-names',
  JOB_FAMILY_GROUPS = 'job-family-groups',
}
